import m from "color";
import v from "chroma-js";
import { css as B } from "@emotion/react";
import { omit as j } from "@illa-design/system";
const y = "illa";
function A(f) {
  return f == "transparent" ? "transparent" : s.get(f) ?? "";
}
function z(f) {
  return s.has(f);
}
const s = /* @__PURE__ */ new Map([
  ["--illa-white-01", "#ffffffff"],
  ["--illa-white-02", "#ffffffe6"],
  ["--illa-white-03", "#ffffffbf"],
  ["--illa-white-04", "#ffffff80"],
  ["--illa-white-05", "#ffffff4d"],
  ["--illa-white-06", "#ffffff33"],
  ["--illa-white-07", "#ffffff29"],
  ["--illa-white-08", "#ffffff1f"],
  ["--illa-white-09", "#ffffff1a"],
  ["--illa-gray-01", "#000000ff"],
  ["--illa-gray-02", "#1f1f1fff"],
  ["--illa-gray-03", "#5c5c5cff"],
  ["--illa-gray-04", "#999999ff"],
  ["--illa-gray-05", "#c2c2c2ff"],
  ["--illa-gray-06", "#d6d6d6ff"],
  ["--illa-gray-07", "#e0e0e0ff"],
  ["--illa-gray-08", "#ebebebff"],
  ["--illa-gray-09", "#f5f5f5ff"],
  ["--illa-grayBlue-01", "#0b0c0fff"],
  ["--illa-grayBlue-02", "#1d2129ff"],
  ["--illa-grayBlue-03", "#787e85ff"],
  ["--illa-grayBlue-04", "#a9aeb8ff"],
  ["--illa-grayBlue-05", "#bbc0c9ff"],
  ["--illa-grayBlue-06", "#c9cdd4ff"],
  ["--illa-grayBlue-07", "#dadee5ff"],
  ["--illa-grayBlue-08", "#e5e6ebff"],
  ["--illa-grayBlue-09", "#f2f3f5ff"],
  ["--illa-techPurple-n-01", "#5343d0ff"],
  ["--illa-techPurple-01", "#654aecff"],
  ["--illa-techPurple-02", "#775ff2ff"],
  ["--illa-techPurple-03", "#a087f4ff"],
  ["--illa-techPurple-04", "#bca6f7ff"],
  ["--illa-techPurple-05", "#d6c7fbff"],
  ["--illa-techPurple-06", "#eadeffff"],
  ["--illa-techPurple-07", "#f8f5ffff"],
  ["--illa-techPink-n-01", "#c24499ff"],
  ["--illa-techPink-01", "#ff58beff"],
  ["--illa-techPink-02", "#ff75c5ff"],
  ["--illa-techPink-03", "#ff92ceff"],
  ["--illa-techPink-04", "#ffaed8ff"],
  ["--illa-techPink-05", "#ffcbe4ff"],
  ["--illa-techPink-06", "#ffe8f2ff"],
  ["--illa-techPink-07", "#fff5f9ff"],
  ["--illa-blackAlpha-01", "#000000e0"],
  ["--illa-blackAlpha-02", "#000000e6"],
  ["--illa-blackAlpha-03", "#000000bf"],
  ["--illa-blackAlpha-04", "#00000080"],
  ["--illa-blackAlpha-05", "#0000004d"],
  ["--illa-blackAlpha-06", "#00000033"],
  ["--illa-blackAlpha-07", "#00000029"],
  ["--illa-blackAlpha-08", "#00000014"],
  ["--illa-blackAlpha-09", "#0000000a"],
  ["--illa-blue-n-01", "#083bc7ff"],
  ["--illa-blue-01", "#134ae0ff"],
  ["--illa-blue-02", "#175cebff"],
  ["--illa-blue-03", "#1e6fffff"],
  ["--illa-blue-04", "#5c99ffff"],
  ["--illa-blue-05", "#99beffff"],
  ["--illa-blue-06", "#c2d8ffff"],
  ["--illa-blue-07", "#edf4ffff"],
  ["--illa-purple-n-01", "#6f2fc4ff"],
  ["--illa-purple-01", "#833fdfff"],
  ["--illa-purple-02", "#8e4be0ff"],
  ["--illa-purple-03", "#a55bf5ff"],
  ["--illa-purple-04", "#c87ffaff"],
  ["--illa-purple-05", "#dfb2fcff"],
  ["--illa-purple-06", "#f0d6feff"],
  ["--illa-purple-07", "#fbf2feff"],
  ["--illa-red-n-01", "#c21f1fff"],
  ["--illa-red-01", "#e02424ff"],
  ["--illa-red-02", "#eb3639ff"],
  ["--illa-red-03", "#ff4747ff"],
  ["--illa-red-04", "#ff7272ff"],
  ["--illa-red-05", "#ffa3a3ff"],
  ["--illa-red-06", "#fcccccff"],
  ["--illa-red-07", "#feeeeeff"],
  ["--illa-green-n-01", "#006134ff"],
  ["--illa-green-01", "#007a41ff"],
  ["--illa-green-02", "#118f58ff"],
  ["--illa-green-03", "#00aa5bff"],
  ["--illa-green-04", "#00d689ff"],
  ["--illa-green-05", "#66dfb0ff"],
  ["--illa-green-06", "#d9ffeaff"],
  ["--illa-green-07", "#ecfbf5ff"],
  ["--illa-yellow-n-01", "#c76b00ff"],
  ["--illa-yellow-01", "#e07800ff"],
  ["--illa-yellow-02", "#eb9000ff"],
  ["--illa-yellow-03", "#ffab00ff"],
  ["--illa-yellow-04", "#ffcd00ff"],
  ["--illa-yellow-05", "#ffe266ff"],
  ["--illa-yellow-06", "#fff2a3ff"],
  ["--illa-yellow-07", "#fffcebff"],
  ["--illa-orange-n-01", "#c72c15ff"],
  ["--illa-orange-01", "#e03118ff"],
  ["--illa-orange-02", "#eb4825ff"],
  ["--illa-orange-03", "#ff5e2fff"],
  ["--illa-orange-04", "#ff8246ff"],
  ["--illa-orange-05", "#ffb490ff"],
  ["--illa-orange-06", "#ffd7bfff"],
  ["--illa-orange-07", "#fff5f0ff"],
  ["--illa-cyan-n-01", "#058bb2ff"],
  ["--illa-cyan-01", "#069fccff"],
  ["--illa-cyan-02", "#08a7ccff"],
  ["--illa-cyan-03", "#0cc1e2ff"],
  ["--illa-cyan-04", "#12ddf2ff"],
  ["--illa-cyan-05", "#71ebf7ff"],
  ["--illa-cyan-06", "#d1fcffff"],
  ["--illa-cyan-07", "#effdfeff"],
  ["--illa-brand-01", "#654aecff"],
  ["--illa-brand-02", "#ff58beff"]
]), W = ["hex", "rgb", "hsl"];
function F(f) {
  return !f || W.indexOf(f) < 0 ? "hex" : f;
}
const H = (f, l, t) => {
  const e = F(l);
  return e === "hex" ? f[e]() : f[e]().alpha(t).round().string();
};
function I(f, l, t = "hex") {
  const e = m(f), d = e.alpha(), n = e.hue(), r = e.saturationv(), o = e.value(), b = 2, x = 100, h = 9, w = 100, $ = 30;
  function P(c, i) {
    let a;
    return n >= 60 && n <= 240 ? a = c ? n - b * i : n + b * i : a = c ? n + b * i : n - b * i, a < 0 ? a += 360 : a >= 360 && (a -= 360), Math.round(a);
  }
  function S(c, i) {
    let a;
    return c ? a = r <= h ? r : r - (r - h) / 5 * i : a = r + (x - r) / 4 * i, a;
  }
  function k(c, i) {
    return c ? o + (w - o) / 5 * i : o <= $ ? o : o - (o - $) / 4 * i;
  }
  const u = l < 6, g = u ? 6 - l : l - 6, C = l === 6 ? e : m({
    h: P(u, g),
    s: S(u, g),
    v: k(u, g)
  });
  return H(C, t, d);
}
const N = {
  "n-01": 9,
  "01": 8,
  "02": 7,
  "03": 6,
  "04": 5,
  "05": 4,
  "06": 2,
  "07": 1
}, R = (f, l) => {
  let t;
  if (f === "transparent")
    return "#00000000";
  if (z(`--${y}-${f}-${l}`))
    t = A(`--${y}-${f}-${l}`);
  else {
    const e = N[l];
    let d = e || 6;
    try {
      t = I(f, d, "hsl");
    } catch {
      t = "#00000000";
    }
  }
  return t;
}, M = (f, l) => `0 0 8px 0
        ${v(R(f, l)).alpha(0.15).hex()}`;
function T(f) {
  return B`
    //SizeStyledProps
    width: ${f.w};
    min-width: ${f.minW};
    max-width: ${f.maxW};
    height: ${f.h};
    min-height: ${f.minH};
    max-height: ${f.maxH};
    padding-top: ${f.pt};
    padding-bottom: ${f.pb};
    padding-left: ${f.pl};
    padding-right: ${f.pr};
    padding: ${f.pd};
    margin-left: ${f.ml};
    margin-right: ${f.mr};
    margin-top: ${f.mt};
    margin-bottom: ${f.mb};
    margin: ${f.mg};
    //ShapeStyledProps
    border-top: ${f.bt};
    border-bottom: ${f.bb};
    border-left: ${f.bl};
    border-right: ${f.br};
    border-radius: ${f.bdRadius};
    border: ${f.bd};
    //ColorStyledProps
    background: ${f.bg};
    background-color: ${f.bgColor};
    border-color: ${f.bdColor};
    color: ${f.c};
    opacity: ${f.opac};
    //PositionStyledProps
    position: ${f.pos};
    top: ${f.posT};
    left: ${f.posL};
    bottom: ${f.posB};
    right: ${f.posR};
    z-index: ${f.z};
    overflow: ${f.ov};
    overflow-x: ${f.ovX};
    overflow-y: ${f.ovY};
    // FlexStyledProps
    align-items: ${f.alignItems};
    align-content: ${f.alignContent};
    justify-content: ${f.justifyContent};
    justify-items: ${f.justifyItems};
    flex-wrap: ${f.flexWrap};
    flex-direction: ${f.flexDirection};
    flex: ${f.flex};
    flex-grow: ${f.flexGrow};
    flex-shrink: ${f.flexShrink};
    flex-basis: ${f.flexBasis};
    justify-self: ${f.justifySelf};
    align-self: ${f.alignSelf};
    order: ${f.o};
    //FontStyledProps
    font-size: ${f.fs};
    font-family: ${f.ff};
    font-weight: ${f.fw};
    visibility: ${f.v};
    // UserProps
    cursor: ${f.cur};
    ${f._css};
  `;
}
function X(f) {
  return j(f, [
    //SizeStyledProps
    "w",
    "minW",
    "maxW",
    "h",
    "minH",
    "maxH",
    "pt",
    "pb",
    "pl",
    "pr",
    "pd",
    "ml",
    "mr",
    "mt",
    "mb",
    "mg",
    //ShapeStyledProps
    "bt",
    "bb",
    "bl",
    "br",
    "bdRadius",
    "bd",
    //ColorStyledProps
    "bg",
    "bgColor",
    "bdColor",
    "c",
    "opac",
    //PositionStyledProps
    "pos",
    "posT",
    "posL",
    "posB",
    "posR",
    "z",
    "ov",
    "ovX",
    "ovY",
    "v",
    // FlexStyledProps
    "alignItems",
    "alignContent",
    "justifyContent",
    "justifyItems",
    "flexWrap",
    "flexDirection",
    "flex",
    "flexGrow",
    "flexShrink",
    "flexBasis",
    "justifySelf",
    "alignSelf",
    "o",
    //FontStyledProps
    "fs",
    "ff",
    "fw",
    //UserProps
    "cur",
    "_css"
  ]);
}
const Y = {
  auto: "auto",
  hide: -1,
  base: 0,
  inputFocus: 2,
  tabs: 2,
  button: 2,
  modal: 1e3,
  drawer: 1001,
  notification: 1002,
  message: 1003,
  table: 1
};
export {
  T as applyBoxStyle,
  I as colorPalette,
  X as deleteCssProps,
  R as getColor,
  M as getColorShadow,
  H as getColorString,
  A as globalColor,
  z as hasGlobalColor,
  y as illaPrefix,
  Y as zIndex
};
//# sourceMappingURL=index.js.map
